import { Injectable } from '@angular/core';
import {
  CurrentDepartmentService,
  CurrentUserService,
  User,
  Department,
} from '@frontend/common/util';
import { Observable } from 'rxjs';
import { map, shareReplay, distinctUntilChanged } from 'rxjs/operators';

@Injectable()
export class ToolbarService {
  public department$: Observable<Department | null>;
  public user$: Observable<{ name: string; email: string }>;

  constructor(
    private currentUserSrv: CurrentUserService,
    private currentDepartmentSrv: CurrentDepartmentService
  ) {
    this.department$ = this.currentDepartmentSrv.department$.pipe(
      distinctUntilChanged((prev, curr) => {
        if (!prev && !curr) return true;
        if (!prev || !curr) return false;
        return prev.id === curr.id;
      }),
      shareReplay(1)
    );

    this.user$ = this.currentUserSrv.user$.pipe(
      map(userManipulation),
      shareReplay(1)
    );
  }
}

export function userManipulation(user: User) {
  const name = [user.first_name, user.last_name].filter((item) => !!item).join(' ');
  const email = user.email;
  return { name, email };
}
